// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";
import "./SVGCheckmarkIcon.styl";
const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGDownloadIcon extends PureComponent {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        //fill={fill || "currentColor"}
        background-color="rgb(255,255,255)"
        style={style}
        width="35px"
        height="29px"
        viewBox="0 0 35 29"
        enableBackground="new 0 0 35 29"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#8694B1"
          d="M18.135,0c0.504,0,1.008,0,1.512,0c0,5.291,0,10.583,0,15.873
	c0.031,0,0.063,0,0.094,0c0.839-1.231,2.321-2.229,3.4-3.266c0.447-0.429,0.872-1.142,1.511-1.36
	c0.301,0.432,0.844,0.657,1.039,1.179c-1.668,1.572-3.337,3.144-5.006,4.716c-0.543,0.521-1.126,1.459-1.89,1.724
	c-1.636-1.603-3.274-3.205-4.911-4.807c-0.543-0.521-1.52-1.082-1.794-1.814c0.45-0.29,0.685-0.811,1.228-0.998
	c0.593,0.865,1.604,1.54,2.361,2.268c0.787,0.756,1.521,1.765,2.456,2.358C18.135,10.583,18.135,5.291,18.135,0z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#8694B1"
          d="M16.624,7.256c0,0.483,0,0.967,0,1.451c-2.739,0-5.479,0-8.217,0
	c-0.363,1.152-1.44,2.205-2.078,3.174c-0.877,1.332-1.581,2.658-2.457,3.991c-0.642,0.979-1.431,1.921-1.982,2.993
	c3.399,0,6.8,0,10.2,0c-0.031,2.091-0.202,4.3,1.04,5.169c1.551,1.087,5.445,0.635,8.028,0.635c1.545,0,2.635-0.029,3.495-0.635
	c1.24-0.874,1.07-3.075,1.039-5.169c3.399,0,6.801,0,10.201,0c0-0.031,0-0.061,0-0.091c-0.496-0.512-0.733-1.205-1.133-1.814
	c-0.78-1.188-1.558-2.403-2.361-3.628c-0.621-0.947-1.244-1.918-1.889-2.902c-0.36-0.549-0.901-1.053-1.133-1.723
	c-2.739,0-5.479,0-8.218,0c0-0.484,0-0.968,0-1.451c3.022,0,6.045,0,9.067,0c1.695,2.896,3.621,5.694,5.478,8.526
	c0.463,0.706,0.93,1.434,1.417,2.176c0.157,0.239,0.553,0.554,0.662,0.817c0,4.383,0,8.768,0,13.151c-12.592,0-25.188,0-37.781,0
	c0-4.383,0-8.769,0-13.151c0.216-0.517,0.824-1.071,1.133-1.542c1.122-1.707,2.208-3.409,3.306-5.08
	c0.804-1.224,1.581-2.44,2.361-3.627c0.209-0.319,0.415-1.112,0.755-1.27C10.579,7.256,13.602,7.256,16.624,7.256z"
        />
      </svg>
    );
  }
}
